import React, { ReactNode } from "react"

import { Paper, cn } from "@podcastsoundboard/ps-lib/ui"

interface HeadingContainerProps {
  minHeight?: string
  children: ReactNode
  className?: string
}

const HeadingContainer: React.FC<HeadingContainerProps> = (props) => {
  return (
    <Paper
      square
      className={cn(
        "flex flex-row items-center justify-between px-6 shadow-paper",
        props.className,
      )}
      style={{ minHeight: props.minHeight || "64px" }}
    >
      {props.children}
    </Paper>
  )
}
export default HeadingContainer
